module.exports = __webpack_public_path__ + "img/section4.8104e0c6.png";